import { axios } from '../request'

export default (app) => {
  return {
    namespaced: true,
    state: {
      owedPerYear: [],
      nextYearQuotaExpectations: {},
      paidPerYear: [],
      canceledPerYear: [],
      membershipsPerYear: [],
    },
    mutations: {
      setOwedPerYear(state, owedPerYear) {
        state.owedPerYear = owedPerYear
      },
      setNextYearQuotaExpectations(state, owedPerYear) {
        state.nextYearQuotaExpectations = owedPerYear
      },
      setPaidPerYear(state, paidPerYear) {
        state.paidPerYear = paidPerYear
      },
      setCanceledPerYear(state, canceledPerYear) {
        state.canceledPerYear = canceledPerYear
      },
      setMembershipsPerYear(state, membershipsPerYear) {
        state.membershipsPerYear = membershipsPerYear
      },
    },
    actions: {
      getOwedPerYear(context) {
        return new Promise((resolve) => {
          axios
            .get(`/reports/owedPerYear`)
            .then((res) => {
              context.commit('setOwedPerYear', res.data.data)
              resolve()
            })
            .catch(() => {})
        })
      },
      getNextYearQuotaExpectations(context) {
        return new Promise((resolve) => {
          axios
            .get(`/reports/nextYearQuotaExpectations`)
            .then((res) => {
              context.commit('setNextYearQuotaExpectations', res.data.data)
              resolve()
            })
            .catch(() => {})
        })
      },
      getPaidPerYear(context) {
        return new Promise((resolve) => {
          axios
            .get(`/reports/paymentsPerYear`)
            .then((res) => {
              context.commit('setPaidPerYear', res.data.data)
              resolve()
            })
            .catch(() => {})
        })
      },
      getCanceledPerYear(context) {
        return new Promise((resolve) => {
          axios
            .get(`/reports/cancelationsPerYear`)
            .then((res) => {
              context.commit('setCanceledPerYear', res.data.data)
              resolve()
            })
            .catch(() => {})
        })
      },
      getMembershipsPerYear(context) {
        return new Promise((resolve) => {
          axios
            .get(`/reports/membershipsPerYear`)
            .then((res) => {
              context.commit('setMembershipsPerYear', res.data.data)
              resolve()
            })
            .catch(() => {})
        })
      },
    },
  }
}
